import React from 'react';
import { APPLE_THEME, TYPOGRAPHY } from '../theme';

const Tile = ({ icon, label, href }) => (
  <a
  className="tile"
    href={href}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      textDecoration: 'none',
      background: APPLE_THEME.white,
      border: `1px solid ${APPLE_THEME.lightMetalicGray}`,
      borderRadius: 16,
      padding: '12px 14px',
      transition: 'box-shadow 200ms ease, transform 200ms ease'
    }}
    onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
    onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
  >
    <div style={{ width: 32, height: 32, borderRadius: 10, background: APPLE_THEME.lightMetalicGray, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}> {icon} </div>
    <span style={{ color: APPLE_THEME.metalicBlack, fontFamily: TYPOGRAPHY.body, fontSize: 14 }}>{label}</span>
  </a>
);

const PopularActions = () => {
  const items = [
    { icon: '📱', label: 'Ekran Değişimi', href: '/hizmetler' },
    { icon: '🔋', label: 'Pil Değişimi', href: '/hizmetler' },
    { icon: '💧', label: 'Sıvı Teması', href: '/hizmetler' },
    { icon: '🧰', label: 'Genel Bakım', href: '/hizmetler' },
    { icon: '💬', label: 'Teknik Destek', href: '/destek' },
    { icon: '📦', label: 'Mağazadan Teslim', href: '/iletisim' }
  ];

  return (
    <section aria-label="Popüler İşlemler" style={{ background: APPLE_THEME.backgroundGray, padding: '8px 0 28px 0' }}>
      <div style={{ maxWidth: 980, margin: '0 auto', padding: '0 20px' }}>
        <div className="tiles-wrap" style={{ position: 'relative' }}>
          <div className="tiles" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 }}>
            {items.map((it, i) => (
              <Tile key={i} icon={it.icon} label={it.label} href={it.href} />
            ))}
          </div>
          <div className="tiles-fade" aria-hidden style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: 28, pointerEvents: 'none', background: `linear-gradient(to left, ${APPLE_THEME.backgroundGray}, transparent)` }} />
          <div className="tiles-chev" aria-hidden style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', display: 'none' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={APPLE_THEME.metalicGray} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PopularActions;
